<section class="capacity-page">
    <div class="capacity-header">
        <div>
            <h2>Kapazitätsplanung</h2>

        </div>
        <button mat-stroked-button (click)="setToday()">
            <mat-icon>today</mat-icon>
            Heute
        </button>
    </div>

    <p class="error-message" *ngIf="accessError">{{ accessError }}</p>
    <div class="filter-panel" *ngIf="!accessLoading && !accessError">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="isGlobalPlanner || availableTeams.length > 1">
            <mat-label>Planungsbereich</mat-label>
            <mat-select [(ngModel)]="selectedTeamId" (ngModelChange)="onTeamChange()">
                <mat-option *ngIf="isGlobalPlanner" [value]="null">Gesamtplanung</mat-option>
                <mat-option *ngFor="let team of availableTeams" [value]="team.teamId">{{ team.teamName }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Von</mat-label>

            <input matInput [matDatepicker]="fromPicker" [(ngModel)]="fromDate" (dateChange)="onDateSelected('from')">

            <mat-datepicker-toggle matIconSuffix [for]="fromPicker">
            </mat-datepicker-toggle>

            <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Bis</mat-label>

            <input matInput [matDatepicker]="toPicker" [(ngModel)]="toDate" (dateChange)="onDateSelected('to')">

            <mat-datepicker-toggle matIconSuffix [for]="toPicker">
            </mat-datepicker-toggle>

            <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
        <div class="period-navigation">
            <button mat-icon-button type="button" matTooltip="Vorheriger Zeitraum" (click)="navigatePeriod(-1)">
                <mat-icon>chevron_left</mat-icon>
            </button>

            <button mat-icon-button type="button" matTooltip="Nächster Zeitraum" (click)="navigatePeriod(1)">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Ansicht</mat-label>
            <mat-select [(ngModel)]="granularity" (ngModelChange)="onGranularityChange()">
                <mat-option *ngFor="let option of granularities" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Skills</mat-label>
            <mat-select multiple [(ngModel)]="selectedSkillIds" (ngModelChange)="loadReport()">
                <mat-option *ngFor="let skill of visibleSkills" [value]="skill.id">{{ skill.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <p class="error-message" *ngIf="error">{{ error }}</p>
    <div class="loading-state" *ngIf="loading">Kapazitäten werden geladen ...</div>

    <ng-container *ngIf="report && !loading">
        <div class="summary-grid">
            <div class="summary-card"><span>Verfügbare Stunden</span><strong>{{ report.totals.availableHours |
                    number:'1.0-1':'de-AT' }} h</strong></div>
            <div class="summary-card"><span>Geplante Stunden</span><strong>{{ report.totals.plannedHours |
                    number:'1.0-1':'de-AT' }} h</strong></div>
            <div class="summary-card"><span>Freie Kapazität</span><strong>{{ report.totals.remainingHours |
                    number:'1.0-1':'de-AT' }} h</strong></div>
            <div class="summary-card"><span>Gesamtauslastung</span><strong>{{ report.totals.utilizationPercent |
                    number:'1.0-1':'de-AT' }} %</strong></div>
            <div class="summary-card"><span>Mitarbeiter über 100 % im Zeitraum</span><strong>{{ overloadedEmployees
                    }}</strong></div>
        </div>

        <div class="section-card">
            <div class="section-heading">
                <h3>Mitarbeiterauslastung</h3>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Mitarbeiter suchen</mat-label>
                    <input matInput [(ngModel)]="searchText">
                </mat-form-field>
            </div>

            <div class="employee-entry" *ngFor="let employee of employees">
                <div class="employee-row" (click)="toggleEmployee(employee.userId)" role="button" tabindex="0"
                    (keydown.enter)="toggleEmployee(employee.userId)">
                    <div class="employee-name">
                        <strong>{{ employee.name }}</strong>
                        <small>{{ employee.weeklyCapacityHours | number:'1.0-1':'de-AT' }} h/Woche</small>
                    </div>
                    <div class="utilization-area">
                        <div class="utilization-meta">
                            <span>{{ employee.totals.plannedHours | number:'1.0-1':'de-AT' }} / {{
                                employee.totals.availableHours | number:'1.0-1':'de-AT' }} h</span>
                            <strong [class.warning-text]="employee.totals.utilizationPercent > 100">{{
                                employee.totals.utilizationPercent | number:'1.0-1':'de-AT' }} %</strong>
                        </div>
                        <div class="utilization-track">
                            <div class="utilization-fill"
                                [ngClass]="utilizationClass(employee.totals.utilizationPercent)"
                                [style.width.%]="barWidth(employee.totals.utilizationPercent)"></div>
                        </div>
                    </div>
                    <span class="overload-hint" *ngIf="employee.totals.overloadedDays > 0">
                        {{ employee.totals.overloadedDays }} Tage mit Überlastung
                    </span>
                    <mat-icon>{{ expandedUserId === employee.userId ? 'expand_less' : 'expand_more' }}</mat-icon>
                </div>
                <div class="employee-detail" *ngIf="expandedUserId === employee.userId">
                    <h4>Auslastung nach Zeitabschnitt</h4>
                    <div class="detail-row" *ngFor="let bucket of employee.buckets">
                        <span>{{ bucket.label }}</span>
                        <span>{{ bucket.plannedHours | number:'1.0-1':'de-AT' }} / {{ bucket.availableHours |
                            number:'1.0-1':'de-AT' }} h</span>
                        <strong>{{ bucket.utilizationPercent | number:'1.0-1':'de-AT' }} %</strong>
                    </div>
                    <h4 *ngIf="employee.conflicts.length">Konflikte</h4>
                    <div class="conflict-row" *ngFor="let conflict of employee.conflicts">
                        <mat-icon>warning_amber</mat-icon>
                        <span>{{ conflict.date | date:'dd.MM.yyyy' }} – {{ conflict.message }}</span>
                    </div>
                </div>
            </div>
            <div class="empty-state" *ngIf="employees.length === 0">Keine Mitarbeiter für diese Auswahl gefunden.</div>
        </div>

        <div class="section-card" *ngIf="report.conflicts.length">
            <h3>Planungskonflikte ({{ report.conflicts.length }})</h3>
            <div class="conflict-row" *ngFor="let conflict of report.conflicts">
                <mat-icon>warning_amber</mat-icon>
                <span><strong>{{ conflict.userName }}</strong> · {{ conflict.date | date:'dd.MM.yyyy' }} – {{
                    conflict.message }}</span>
            </div>
        </div>
    </ng-container>
</section>